(async () => {
    const { Core } = await importModule('Core');
    const { parseHTML, Routes } = await importModule('Utils');

    customElements.define('add-more-products', class extends Core {

        elements = {
            moreProductsButton: '[add-more-products]',
        }
        
        render() {
            this.count = 1;
            this.$moreProductsButton.addEventListener('click', this._addMoreProducts.bind(this))
        }

        
        async _addMoreProducts() {
          debugger;
            this.count = this.count + 1;
            var parentDiv = this.closest("div");
            var tempDiv = document.createElement("div");
            tempDiv.style.setProperty("--span","6");
            tempDiv.style.setProperty("--span-mobile","12");
            tempDiv.innerHTML = '<div class="#form-field"><label class="#form-field-label" for="ContactForm-custom-field-product-'+this.count+'"><span class="asterisk-wrapper">*</span>Product</label><input class="#form-field-input" id="ContactForm-custom-field-product-'+this.count+'" required="" type="text" name="contact[Additional Product '+this.count+']"></div>';
            parentDiv.insertBefore(tempDiv, this);

            var tempDiv = document.createElement("div");
            tempDiv.style.setProperty("--span","6");
            tempDiv.style.setProperty("--span-mobile","12");
            tempDiv.innerHTML = '<div class="#form-field"><label class="#form-field-label" for="ContactForm-custom-field-quantity-'+this.count+'"><span class="asterisk-wrapper">*</span>Quantity</label><input class="#form-field-input" id="ContactForm-custom-field-quantity-'+this.count+'" required="" type="text" name="contact[Additional Quantity '+this.count+']"></div>';
            parentDiv.insertBefore(tempDiv, this);
        }

    })
})();